import React from "react";
import {labelizeUnderScoreText, useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {MedicalElement as MedicalChipElement} from "crqlar-react-common/dist/components/uiElements/MedicalElement";
import {ElementChipList} from "./base/ElementChipList";

interface Props {
    medical: string[] | undefined;
    onClick?: (value: string) => void;
    onDelete?: (value: string) => void;
}

export function MedicalElement({medical, onClick, onDelete}: Props) {
    const {tFallback} = useLocalize();
    const uniqueMedical = Array.from(new Set((medical ?? []).filter(Boolean)));

    if (!uniqueMedical.length) return null;

    return (
        <ElementChipList>
            {uniqueMedical.map(value => (
                <MedicalChipElement
                    key={value}
                    label={tFallback(
                        `Common health preference value ${value}`,
                        labelizeUnderScoreText(value),
                    )}
                    value={value}
                    onClick={onClick ? () => onClick(value) : undefined}
                    onDelete={onDelete ? () => onDelete(value) : undefined}
                />
            ))}
        </ElementChipList>
    );
}
